import {
    required,
    email,
    minLength,
    maxLength,
    numeric,
    sameAs
} from "vuelidate/lib/validators";
import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import axios from "axios";
import $ from "jquery";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import store from "@/store";

export default {
    name: "applicantRegister",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            signupForm: {
                name: this.data ? this.data.name : '',
                email: this.data ? this.data.email : '',
                password: this.password,
                password_confirmation: this.password_confirmation,
                phone_number: this.data ? this.data.phone_number : '',
                // address: this.address,
                // gender: 1
            },
            submitted: false,
            error_email: "",
            social_id: this.data ? this.data.social_id : null,
            pass_error: false,
            pass_confirm_error: false
        };
    },

    props: ['data'],

    validations: {
        signupForm: {
            name: {
                required,
                maxLength: maxLength(100)
            },
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(6)
            },
            password_confirmation: {
                sameAsPassword: sameAs("password"),
                required
            },
            phone_number: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(11),
                numeric
            },
            // address: {
            //     required
            // },
            // gender: {
            //     required
            // }
        }
    },

    methods: {
        submitSignUp() {
            this.submitted = true;
            if (!this.social_id) {
                if (this.signupForm.password == null) {
                    this.pass_error = true;
                } else this.pass_error = false;
                if (this.signupForm.password_confirmation == null) {
                    this.pass_confirm_error = true;
                } else this.pass_confirm_error = false;
                if (this.pass_error || this.pass_confirm_error) {
                    return;
                }
            }
            if (this.$v.signupForm.$invalid) {
                console.log(this.$v.signupForm);
                console.log("signup validation error");
                return;
            }
            this.signupApplicant();
        },

        signupApplicant() {
            $("#block-btn").attr("disabled", true);
            this.isLoading = true;
            var request = {
                social_id: this.social_id,
                name: this.signupForm.name,
                email: this.signupForm.email,
                password: this.signupForm.password,
                password_confirmation: this.signupForm.password_confirmation,
                phone_number: this.signupForm.phone_number,
                // address: this.signupForm.address,
                // gender: this.signupForm.gender
            };
            axios.post("/applicant/register", request)
                .then(response=> {
                    $("#block-btn").attr("disabled", false);
                    console.log("API Success", response.data);
                    if (response.data.msg) {
                        this.error_email = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else if (response.data.data) {
                        if (response.data.data.token) {
                            store.commit("setApplicantData", response.data.data);
                            this.$router.push({
                                name: 'homeIndex'
                            });
                        }
                    } else {
                        localStorage.setItem('loginEmail', response.data.email);
                        this.isLoading = false;
                        this.$router.push({
                            name: "applicantLogin"
                        });
                    }
                });
        }
    }
};
